module.exports = __webpack_public_path__ + "static/img/259_TO8_2327.573b711.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/259_TO8_2327.jpg
// module id = jv+L
// module chunks = 0